import styled from 'styled-components'

import { black } from '../../styles/colors'

export const Header = styled.div`
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 2rem;
  text-align: center;
  color: ${black};
`

export const Description = styled.div`
  font-size: 16px;
  font-weight: 300;
  text-align: center;
  line-height: 1.5;
  max-width: 600px;
  margin: 1rem auto;
`



// WEBPACK FOOTER //
// ./src/views/Confirmation/styles.js